// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-file-container {
  position: relative;
}
.input-file-container .files-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-top: 1.25rem;
}
.input-file-container .file-container, .input-file-container .file-button {
  align-items: center;
  display: flex;
  height: 10rem;
  justify-content: center;
  width: 10rem;
}
.input-file-container .secondary-button {
  width: 10rem;
}
.input-file-container .file-button {
  flex: 1;
}
.input-file-container .file-container {
  flex-direction: column;
  margin-right: 1rem;
  overflow: hidden;
}
.input-file-container .replace-button {
  flex: 1;
  width: 10rem;
}
.input-file-container .mat-button:focus {
  outline: 0;
}
.input-file-container .file-name {
  width: calc(10rem - 2.5rem);
}
.input-file-container .image-preview {
  position: absolute;
  height: 10rem;
  object-fit: contain;
  width: 10rem;
}
.input-file-container .input-icon {
  font-size: calc(10rem / 4);
  height: calc(10rem / 4);
  width: calc(10rem / 4);
}
.input-file-container .form-link {
  display: flex;
  flex-direction: column;
  width: 10rem;
}
.input-file-container .input-link {
  width: 10rem;
}
.input-file-container .form-link-button {
  display: flex;
  flex-direction: row;
}
.input-file-container .form-link-button .mat-button {
  min-width: calc(10rem / 2);
  width: calc(10rem / 2);
}
.input-file-container .mat-orphan-label {
  color: rgba(0, 0, 0, 0.54);
  display: block;
  font-size: 1rem;
  left: 0;
  margin: 0;
  position: absolute;
  top: 0;
  transform-origin: 0;
  transition: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), width 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.input-file-container .mat-orphan-label.active {
  transform: scale(0.75);
}

@keyframes bounceIn {
  from, 20%, 40%, 60%, 80%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }
  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
.bounce-in {
  animation-duration: 0.75s;
  animation-name: bounceIn;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.slide-in-up {
  animation-duration: 0.25s;
  animation-name: slideInUp;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/input-file/components/input-file/input-file.scss"],"names":[],"mappings":"AAGI;EACI,kBAAA;AAFR;AAIQ;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAFZ;AAKQ;EACI,mBAAA;EACA,aAAA;EACA,aAqJQ;EApJR,uBAAA;EACA,YAmJe;AAtJ3B;AAMQ;EACI,YA+Ie;AAnJ3B;AAOQ;EAGI,OAAA;AAPZ;AAUQ;EAGI,sBAAA;EACA,kBAAA;EACA,gBAAA;AAVZ;AAaQ;EACI,OAAA;EACA,YA4He;AAvI3B;AAeY;EACI,UAAA;AAbhB;AAiBQ;EACI,2BAAA;AAfZ;AAkBQ;EACI,kBAAA;EACA,aA6GQ;EA5GR,mBAAA;EACA,YA2Ge;AA3H3B;AAmBQ;EACI,0BAAA;EACA,uBAAA;EACA,sBAAA;AAjBZ;AAoBQ;EACI,aAAA;EACA,sBAAA;EACA,YA+Fe;AAjH3B;AAqBQ;EACI,YA2Fe;AA9G3B;AAsBQ;EACI,aAAA;EACA,mBAAA;AApBZ;AAsBY;EACI,0BAAA;EACA,sBAAA;AApBhB;AAwBQ;EACI,0BAvFG;EAwFH,cAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,8FAAA;AAtBZ;AAwBY;EACI,sBAAA;AAtBhB;;AA2BI;EACI;IAMI,8DAAA;EA7BV;EAgCM;IACI,UAAA;IACA,iCAAA;EA9BV;EAiCM;IACI,iCAAA;EA/BV;EAkCM;IACI,iCAAA;EAhCV;EAmCM;IACI,UAAA;IACA,oCAAA;EAjCV;EAoCM;IACI,oCAAA;EAlCV;EAqCM;IACI,UAAA;IACA,2BAAA;EAnCV;AACF;AAsCI;EACI,yBAAA;EACA,wBAAA;AApCR;;AAuCI;EACI;IACI,UAAA;IACA,kCAAA;EApCV;EAuCM;IACI,UAAA;IACA,+BAAA;EArCV;AACF;AAwCI;EACI,yBAAA;EACA,yBAAA;AAtCR","sourcesContent":["@mixin input-file($height, $width, $padding) {\r\n    $mat-text: rgba(0, 0, 0, .54);\r\n\r\n    .input-file-container {\r\n        position: relative;\r\n\r\n        .files-container {\r\n            display: flex;\r\n            flex-direction: row;\r\n            flex-wrap: wrap;\r\n            padding-top: 1.25rem;\r\n        }\r\n\r\n        %common-container {\r\n            align-items: center;\r\n            display: flex;\r\n            height: $height;\r\n            justify-content: center;\r\n            width: $width;\r\n        }\r\n\r\n        .secondary-button {\r\n            width: $width;\r\n        }\r\n\r\n        .file-button {\r\n            @extend %common-container;\r\n\r\n            flex: 1;\r\n        }\r\n\r\n        .file-container {\r\n            @extend %common-container;\r\n\r\n            flex-direction: column;\r\n            margin-right: 1rem;\r\n            overflow: hidden;\r\n        }\r\n\r\n        .replace-button {\r\n            flex: 1;\r\n            width: $width;\r\n        }\r\n\r\n        .mat-button {\r\n            &:focus {\r\n                outline: 0;\r\n            }\r\n        }\r\n\r\n        .file-name {\r\n            width: calc(#{$width} - #{$padding});\r\n        }\r\n\r\n        .image-preview {\r\n            position: absolute;\r\n            height: $height;\r\n            object-fit: contain;\r\n            width: $width;\r\n        }\r\n\r\n        .input-icon {\r\n            font-size: calc(#{$width} / 4);\r\n            height: calc(#{$width} / 4);\r\n            width: calc(#{$width} / 4);\r\n        }\r\n\r\n        .form-link {\r\n            display: flex;\r\n            flex-direction: column;\r\n            width: $width;\r\n        }\r\n\r\n        .input-link {\r\n            width: $width;\r\n        }\r\n\r\n        .form-link-button {\r\n            display: flex;\r\n            flex-direction: row;\r\n\r\n            .mat-button {\r\n                min-width: calc(#{$width} / 2);\r\n                width: calc(#{$width} / 2);\r\n            }\r\n        }\r\n\r\n        .mat-orphan-label {\r\n            color: $mat-text;\r\n            display: block;\r\n            font-size: 1rem;\r\n            left: 0;\r\n            margin: 0;\r\n            position: absolute;\r\n            top: 0;\r\n            transform-origin: 0;\r\n            transition: .4s cubic-bezier(.25, .8, .25, 1), width .4s cubic-bezier(.25, .8, .25, 1);\r\n\r\n            &.active {\r\n                transform: scale(.75);\r\n            }\r\n        }\r\n    }\r\n\r\n    @keyframes bounceIn {\r\n        from,\r\n        20%,\r\n        40%,\r\n        60%,\r\n        80%,\r\n        to {\r\n            animation-timing-function: cubic-bezier(.215, .61, .355, 1);\r\n        }\r\n\r\n        0% {\r\n            opacity: 0;\r\n            transform: scale3d(.3, .3, .3);\r\n        }\r\n\r\n        20% {\r\n            transform: scale3d(1.1, 1.1, 1.1);\r\n        }\r\n\r\n        40% {\r\n            transform: scale3d(.9, .9, .9);\r\n        }\r\n\r\n        60% {\r\n            opacity: 1;\r\n            transform: scale3d(1.03, 1.03, 1.03);\r\n        }\r\n\r\n        80% {\r\n            transform: scale3d(.97, .97, .97);\r\n        }\r\n\r\n        to {\r\n            opacity: 1;\r\n            transform: scale3d(1, 1, 1);\r\n        }\r\n    }\r\n\r\n    .bounce-in {\r\n        animation-duration: .75s;\r\n        animation-name: bounceIn;\r\n    }\r\n\r\n    @keyframes slideInUp {\r\n        from {\r\n            opacity: 0;\r\n            transform: translate3d(0, 100%, 0);\r\n        }\r\n\r\n        to {\r\n            opacity: 1;\r\n            transform: translate3d(0, 0, 0);\r\n        }\r\n    }\r\n\r\n    .slide-in-up {\r\n        animation-duration: .25s;\r\n        animation-name: slideInUp;\r\n    }\r\n}\r\n\r\n@include input-file(10rem, 10rem, 2.5rem);\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
